// The foundation's mark, exported from the claude.ai/design project. Its white
// background has been made transparent so it sits on the cream header without
// showing a white box; the footer and admin sidebar put it on a white chip of
// their own, which the design asks for.
export const LOGO = '/assets/logo-mark.png';

export function logoImg({ className = '', alt = 'Janatha Hrudayalaya Foundation' } = {}) {
  const img = document.createElement('img');
  img.src = LOGO;
  img.alt = alt;
  if (className) img.className = className;
  return img;
}
